import { render, staticRenderFns } from "./historyBill.vue?vue&type=template&id=6b025c54&scoped=true"
import script from "./historyBill.vue?vue&type=script&lang=js"
export * from "./historyBill.vue?vue&type=script&lang=js"
import style0 from "./historyBill.vue?vue&type=style&index=0&id=6b025c54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b025c54",
  null
  
)

export default component.exports